import React from "react";
import { formatCount } from "@sscs/utils";
import { getCvssSeverity } from "../../../utils";
import styles from "./cveTooltipCard.module.scss";
/** Roll a component's / dependency's `identity.vulnerabilities` up into the
 * slots the CVE hover card shows: total count, the summed fix-available count
 * across all four lifecycle buckets, and the single highest-scoring CVE (id +
 * base score) found in the buckets' `top_3` previews. The active/triaged split
 * the canvas mockup shows is NOT available per row — see the card header. */
export function deriveCveTooltipData(vulnerabilities) {
    const buckets = [
        vulnerabilities.lifecycle.unproven,
        vulnerabilities.lifecycle.exploit_exists,
        vulnerabilities.lifecycle.exploited_by_malware,
        vulnerabilities.lifecycle.patch_mandated,
    ];
    let mostSevere;
    for (const bucket of buckets) {
        for (const { cve, cvss } of bucket.top_3) {
            if (!mostSevere || cvss.base_score > mostSevere.score) {
                mostSevere = { cve, score: cvss.base_score };
            }
        }
    }
    return {
        totalCount: vulnerabilities.total_count,
        fixableCount: buckets.reduce((sum, bucket) => sum + bucket.fixable_count, 0),
        mostSevere,
    };
}
/** The card's header band: what the hover is about, counted in its own title
 * rather than repeated in a second slot. The band supplies the type and layout,
 * so the title is a plain span. */
export const CveTooltipHeader = ({ totalCount, }) => (React.createElement("span", null, totalCount === undefined
    ? "Vulnerabilities"
    : formatCount(totalCount, "Vulnerability", "Vulnerabilities")));
const CveTooltipCard = ({ fixableCount, mostSevere, }) => (React.createElement("div", { className: styles.card },
    fixableCount !== undefined && React.createElement("div", null,
        fixableCount,
        " with fix available"),
    mostSevere && (React.createElement("div", { className: styles["most-severe"] },
        React.createElement("span", { className: styles.label }, "Most severe"),
        mostSevere.cve !== undefined && React.createElement("span", null, mostSevere.cve),
        React.createElement("span", { className: `${styles.score} ${styles[`score-${getCvssSeverity(mostSevere.score)}`]}` }, mostSevere.score.toFixed(1))))));
export default CveTooltipCard;
//# sourceMappingURL=CveTooltipCard.js.map